import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';
import { fundingSearchMatch, fundingSearchOffer, fundingSearchOffers } from './types';
import {
  requestFundingSearchOfferFailure,
  requestFundingSearchOffersFailure,
  requestFundingSearchOffersSuccess,
  requestFundingSearchOfferSuccess,
  requestFundingSearchMatchSuccess,
  requestFundingSearchMatchFailure,
} from './reducer';

const logger = new Logger('Saga:FundingSearchOffers');

export function* requestFundingSearchOffersSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.platform.matches_by_funding_search_id', {
        fundingSearchId: action.fundingSearchId,
      }),
    );

    yield put(requestFundingSearchOffersSuccess(action.fundingSearchId, response.data));
  } catch (error) {
    logger.error('Failed to request funding search offers with the following error', error);
    yield put(requestFundingSearchOffersFailure(action.fundingSearchId, error));
  }
}

export function* requestFundingSearchOfferSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const { offerId, matchId } = action;

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.platform.funding_matches', {
        matchId,
      }),
    );

    yield put(requestFundingSearchOfferSuccess(offerId, response.data.offer));
    yield put(requestFundingSearchMatchSuccess(matchId, response.data));
  } catch (error) {
    logger.error('Failed to request funding search matches offers with the following error', error);
    yield put(requestFundingSearchOfferFailure(offerId, error));
  }
}

export function* requestFundingSearchMatchSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const { matchId } = action;

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.platform.funding_matches', {
        matchId,
      }),
    );

    yield put(requestFundingSearchMatchSuccess(matchId, response.data));
  } catch (error) {
    logger.error('Failed to request funding search match with the following error', error);
    yield put(requestFundingSearchMatchFailure(matchId, error));
  }
}

export default function* fundingSearchSaga() {
  return yield all([
    takeLatest(fundingSearchOffers.request, requestFundingSearchOffersSaga),
    takeLatest(fundingSearchOffer.request, requestFundingSearchOfferSaga),
    takeLatest(fundingSearchMatch.request, requestFundingSearchMatchSaga),
  ]);
}
